import { ProviderType, RedirectOutputType } from './providerTypes'
import { constructDIDProviderUrl } from '@/utils/didHelpers'

export const frejaId: ProviderType = {
  id: 'frejaId',
  displayName: 'Freja eId',
  showLogo: false,
  showSubmit: false,
  redirectOutput: (): RedirectOutputType => {
    return {
      url: constructDIDProviderUrl(
        {
          provider: 'freja',
          display: 'popup',
          country: 'SE',
          theme: 'piq-1'
        }
      ),
      id: 'frejaId',
      container: 'iframe',
      containerHeight: 300,
      autoShow: {
        default: true,
        mobile: true
      }
    }
  }
}
